import React, {useEffect} from "react";
import "./StatisticPage.sass"
import Window from "../../../_containers/window/Window";
import {useDispatch} from "react-redux";
import {clearStatistic} from "../../../_actions/auth/authReducer";
import {useNavigate} from "react-router";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import {HOME, UNIQUE_HOSTS_CHART, UNIQUE_VISITOR_CHART} from "../../../common/links";

export const StatisticPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(clearStatistic())
    }, [])

    return <Window>
        <div className="StatisticPage-buttons">
            <ButtonComponent onClick={() => navigate(UNIQUE_VISITOR_CHART)}>
                Уникальные посещения по дням
            </ButtonComponent>
            <ButtonComponent onClick={() => navigate(UNIQUE_HOSTS_CHART)}>
                Переходы с других сайтов
            </ButtonComponent>
            <ButtonComponent onClick={() => navigate(HOME)}>
                Назад
            </ButtonComponent>
        </div>
    </Window>
}